import { Box, Typography, Avatar, Stack, Divider } from '@mui/material';
import React, { useState, useEffect } from 'react';
import defaultAlbumThumbnail from '../../assets/default_album_thumbnail.svg';
import theme from '../../theme';
import { useMediaQuery } from '@mui/material';
import AlbumTitleLink from '../../components/common/AlbumTitleLink';

const ItemSearchOption = ({ item }) => {
  const [imageSrc, setImageSrc] = useState(item.albumImageUrl || defaultAlbumThumbnail);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    setImageSrc(item.albumImageUrl || defaultAlbumThumbnail);
  }, [item.albumImageUrl]);

  const handleError = () => {
    setImageSrc(defaultAlbumThumbnail);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        padding: '10px 20px',
        '&:hover': {
          backgroundColor: theme.palette.grey.bg,
        },
        minHeight: '70px',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* 커버 이미지 */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mr: isMobile ? 1 : 2,
          width: isMobile ? 32 : 40,
          height: isMobile ? 32 : 40,
        }}
      >
        <Avatar
          variant="square"
          src={imageSrc}
          alt={item.title}
          onError={handleError}
          sx={{
            width: isMobile ? 32 : 40,
            height: isMobile ? 32 : 40,
          }}
        />
      </Box>

      {/* 정보 */}
      <Stack spacing={1} flex={1} sx={{ minWidth: 0 }}>
        <AlbumTitleLink
          title={item.title}
          contentRating={item.contentRating}
          lineClamp={3}
          sx={{
            fontSize: { xs: 13, md: 14 },
          }}
          iconSx={{
            width: '12px',
            height: '12px',
            marginLeft: 0.5,
          }}
        />
        {isMobile ? (
          <Stack spacing={1} sx={{ minWidth: 0 }}>
            <Typography
              variant="body5"
              color={theme.palette.black[4]}
              sx={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                minWidth: 0,
                lineHeight: 'normal',
              }}
            >
              {item.artist?.name}
            </Typography>
            <Typography
              variant="body5"
              color={theme.palette.black[4]}
              sx={{ lineHeight: 'normal' }}
            >
              {item.releaseDate}
            </Typography>
          </Stack>
        ) : (
          <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
            <Typography
              variant="body3"
              color={theme.palette.black[4]}
              sx={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                minWidth: 0,
                maxWidth: '200px',
                lineHeight: 'normal',
              }}
            >
              {item.artist?.name}
            </Typography>
            <Box sx={{ flexShrink: 0 }}>
              <Divider orientation="vertical" sx={{ height: 8 }} />
            </Box>
            <Typography
              variant="body3"
              color={theme.palette.black[4]}
              sx={{ flexShrink: 0, lineHeight: 'normal' }}
            >
              {item.releaseDate}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default ItemSearchOption;
